export const PolicyTokenParamName = 'token';

